import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Facebook, Instagram } from "lucide-react";

const FACEBOOK_URL = "https://www.facebook.com/share/19NotLSiCH/?mibextid=wwXIfr";
const INSTAGRAM_URL = "https://www.instagram.com/roleplay_connect";

export function Footer() {
  return (
    <footer className="border-t border-border bg-card">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row">
          <div className="max-w-sm">
            <Logo />
            <p className="mt-3 text-sm text-muted-foreground">
              AI-powered clinical role-play practice for AMC Clinical Exam candidates. Practise smarter, walk in confident.
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-2">
              <a
                href={FACEBOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Role-play Connect on Facebook"
                data-testid="footer-facebook-link"
                className="inline-flex items-center gap-2 rounded-full border border-border bg-background px-4 py-2 text-sm font-medium text-foreground transition-colors hover:border-primary hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              >
                <Facebook className="h-4 w-4 text-primary" /> Follow us on Facebook
              </a>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Role-play Connect on Instagram"
                data-testid="footer-instagram-link"
                className="inline-flex items-center gap-2 rounded-full border border-border bg-background px-4 py-2 text-sm font-medium text-foreground transition-colors hover:border-primary hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              >
                <Instagram className="h-4 w-4 text-primary" /> Follow us on Instagram
              </a>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-10 sm:grid-cols-4">
            <div>
              <h4 className="text-sm font-semibold text-foreground">Product</h4>
              <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
                <li><a href="#features" className="hover:text-foreground">Features</a></li>
                <li><a href="#pricing" className="hover:text-foreground">Pricing</a></li>
                <li><Link to="/register" className="hover:text-foreground">Get started</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground">Account</h4>
              <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
                <li><Link to="/login" className="hover:text-foreground">Log in</Link></li>
                <li><Link to="/register" className="hover:text-foreground">Register</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground">Support</h4>
              <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
                <li>
                  <a href="mailto:admin@role-playconnect.com" className="hover:text-foreground" data-testid="footer-support-email">
                    admin@role-playconnect.com
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground">Legal</h4>
              <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
                <li><Link to="/privacy" className="hover:text-foreground">Privacy</Link></li>
                <li><Link to="/terms" className="hover:text-foreground">Terms</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-10 flex flex-col gap-2 border-t border-border pt-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <span>&copy; {new Date().getFullYear()} Role-play Connect. An educational aid &mdash; not medical advice.</span>
          <span>Need help? <a href="mailto:admin@role-playconnect.com" className="font-medium text-primary hover:underline" data-testid="footer-support-email-bottom">admin@role-playconnect.com</a></span>
        </div>
        <p className="mt-4 text-xs leading-5 text-muted-foreground" data-testid="footer-amc-disclaimer">
          Role-play Connect is an independent preparation platform. We are not affiliated, associated, authorized,
          endorsed by, or in any way officially connected with the Australian Medical Council (AMC), or with any of its
          subsidiaries or affiliates. The name &ldquo;Australian Medical Council&rdquo; and the acronym &ldquo;AMC&rdquo;
          are used for identification and descriptive purposes only and remain trademarks of their respective owner.
        </p>
      </div>
    </footer>
  );
}
